export default __webpack_public_path__ + "static/4-55e35212a770457d675d6b8773bb839a.webp";